import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import type { ComponentProps } from 'react';

type CheckTagsProps = ComponentProps<'ul'> & {
	tags: string[];
};

export function CheckTags({ tags, className, ...props }: CheckTagsProps) {
	return (
		<ul
			className={cn(
				'flex flex-wrap gap-x-3 text-2xs text-muted-foreground uppercase tracking-widest',
				className,
			)}
			{...props}
		>
			{tags.map((tag) => (
				<li key={tag} className="flex items-center gap-1">
					<Iconify
						icon="lucide:check"
						className="size-3 shrink-0 text-primary/70"
						aria-hidden="true"
					/>
					{tag}
				</li>
			))}
		</ul>
	);
}
